import React from 'react';
import { Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';

import type { MailersTemplate } from 'bundles/connect/types';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import {
  deleteMailersTemplates, mailersTemplateEditUrl
} from 'bundles/connect/helpers/prospect_api';
import { displayToast } from 'bundles/connect/helpers/display_toast';

type MailersTemplatesTableRowProps = {
  callListId: number;
  template: MailersTemplate;
  selectedTemplates: number[];
  setSelectedTemplates: React.Dispatch<React.SetStateAction<number[]>>;
  setTemplates: React.Dispatch<React.SetStateAction<MailersTemplate[]>>;
}

export default function MailersTemplatesTableRow({
  callListId,
  template,
  selectedTemplates,
  setSelectedTemplates,
  setTemplates
}: MailersTemplatesTableRowProps) {

  const handleChange = () => {
    if (selectedTemplates.includes(template.id)) {
      setSelectedTemplates(selectedTemplates.filter(id => id !== template.id));
    } else {
      setSelectedTemplates([...selectedTemplates, template.id]);
    }
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this template?')) {
      deleteMailersTemplates([template.id]).then(() => {
        displayToast('Template deleted successfully', 'success');
        setSelectedTemplates(prev => prev.filter(id => id !== template.id));
        setTemplates(prev => prev.filter(t => t.id !== template.id));
      });
    }
  };

  return (
    <tr id={`mailers_template_${template.id}`}>
      <td className="py-3 px-4" style={{ width: 36 }}>
        <Form.Check
          checked={selectedTemplates.includes(template.id)}
          className="m-0"
          id={`select_template_${template.id}`}
          type="checkbox"
          onChange={handleChange}
        />
      </td>
      {/* Template */}
      <td className="py-3 px-4 text-truncate">
        <Button
          as="a"
          bsPrefix="btn-link"
          className="p-0 fw-normal text-decoration-underline"
          href={mailersTemplateEditUrl(callListId, template.id)}
        >
          {template.title}
        </Button>
      </td>
      {/* Actions */}
      <td className="py-3 px-4">
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            overlay={<Tooltip>Edit & Use this Template</Tooltip>}
            placement="left"
          >
            <Button
              as="a"
              className="squared p-1"
              href={mailersTemplateEditUrl(callListId, template.id)}
              variant="text-primary"
            >
              <FontAwesomeIcon icon={faPencil} />
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={<Tooltip>Delete Template</Tooltip>}
            placement="left"
          >
            <Button
              className="squared p-1 text-danger"
              variant="text-danger"
              onClick={handleDelete}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </OverlayTrigger>
        </div>
      </td>
    </tr>
  );
}
